"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmrSwitch = void 0;
const react_1 = __importDefault(require("react"));
// Import Spinner Component
const Spinner_1 = require("../Spinner/Spinner");
// Import Switch Styles
const SwitchStyles_1 = require("./SwitchStyles");
const SmrSwitch = ({ disabled = false, errorMessage, leftText, loading = false, onClick, rightText, value = false, }) => {
    const handleOnClick = (e) => {
        if (onClick && !disabled && !loading)
            onClick(e.target.checked);
        return;
    };
    return (react_1.default.createElement(SwitchStyles_1.SwitchErrorContainer, { disabled: disabled },
        react_1.default.createElement(SwitchStyles_1.SwitchContainer, null,
            leftText && react_1.default.createElement(SwitchStyles_1.TextLabel, null, leftText),
            react_1.default.createElement(SwitchStyles_1.Switch, { role: "smr-switch" },
                react_1.default.createElement(SwitchStyles_1.SwitchInput, { role: "smr-switch-input", type: "checkbox", checked: value, onChange: handleOnClick, disabled: disabled }),
                react_1.default.createElement(SwitchStyles_1.Slider, { className: "slider", disabled: disabled, loading: loading }),
                loading && (react_1.default.createElement(SwitchStyles_1.SpinnerContainer, { isChecked: value, role: "spinner" },
                    react_1.default.createElement(Spinner_1.Spinner, { size: "16", color: value ? 'white' : '' })))),
            rightText && react_1.default.createElement(SwitchStyles_1.TextLabel, null, rightText)),
        errorMessage && (react_1.default.createElement(SwitchStyles_1.ErrorLabel, { role: "error-label" }, errorMessage))));
};
exports.SmrSwitch = SmrSwitch;
//# sourceMappingURL=Switch.js.map